import {
    AbstractPmsApiService
} from "./abstract.service";
import {
    ReservationCommunication
} from "../models";

export class ReservationCommunicationPmsApiService extends AbstractPmsApiService {

    get urlPattern() {

        return '/reservation/:reservationId/communication(/:id)';
    }

    newModel(attributes) {

        return new ReservationCommunication(attributes);
    }

    get(params, reservation) {

        const url = this.url({
            reservationId: reservation.id
        });

        return this.http.get(url, {
                headers: this.authHeaders,
                params
            })
            .then(this.getPaginationCollector())
            .catch(this.getErrorHandler);
    }

    show(reservation, model) {

        const url = this.url({
            reservationId: reservation.id,
            id: model.id
        });

        return this.http.get(url, {
                headers: this.authHeaders
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());

    }

    resend(reservation, model) {

        const url = this.url({}, `/reservation/${reservation.id}/resend-message/${model.id}`);

        return this.http.post(url, {}, {headers: this.authHeaders})
        .then(this.getStatusExtractor())
        .catch(this.getErrorHandler());
    }

}


// WEBPACK FOOTER //
// ./src/pms-api/services/reservation-communication.service.js